import { render, staticRenderFns } from "./patient-note.vue?vue&type=template&id=1f04ac3d&scoped=true"
import script from "./patient-note.vue?vue&type=script&lang=js"
export * from "./patient-note.vue?vue&type=script&lang=js"
import style0 from "./patient-note.vue?vue&type=style&index=0&id=1f04ac3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04ac3d",
  null
  
)

export default component.exports